import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';
import { Router } from "@angular/router";
import { User } from "../../shared/models";

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    constructor(
        private http_client: ApiService,
        private router: Router,
    ) { }



    async getUsersList(): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url + 'api/Users', '');
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getUsersDetails(userName: string): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Users/${userName}`);
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async addNewUser(user: User): Promise<any> {
        try {
            const data = await this.http_client.postData(Constant.new_base_url + 'api/Users/register', user);
            return data;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    };
    async updateUser(data: any): Promise<any> {
        try {
            const response = await this.http_client.putData(Constant.new_base_url +
                `api/Users/${data.userName}`, data);
            return true;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async deleteUser(userName: any): Promise<any> {
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url +
                `api/Users/${userName}`);
            return true;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getClientNames(): Promise<any> {
        try {
            const data = await this.http_client.getData(Constant.new_base_url + 'api/list/clients', '');
            return data;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    };

    async getClientData(clientName): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url + 'api/Clients/' + clientName, 'params');
            console.log(response);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getOpenLiability(clientName): Promise<any> {
        try {
            const response = await this.http_client.getData(Constant.new_base_url +
                `api/Clients/${clientName}/GetOpenLiabilitySummary`);
            console.log(response);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async addNewClient(data: any): Promise<any> {
        try {
            const response = await this.http_client.postData(Constant.new_base_url + 'api/Clients', data);
            return true;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateClient(data: any): Promise<any> {
        try {
            const response = await this.http_client.putData(Constant.new_base_url + 'api/Clients/' + data.client1, data);
            return true;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async deleteClient(clientName: any): Promise<any> {
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url
                + 'api/Clients/' + clientName);
            return true;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }


}